<template>
  <div class="wavy-rule flex items-center gap-4
              py-6 px-4 md:px-20">

    <!-- Left wave -->
    <svg class="flex-1" height="20" viewBox="0 0 600 20"
         preserveAspectRatio="none">
      <path
        d="M0 10 C30 6,60 14,90 10 C120 6,150 14,180 10
           C210 6,240 14,270 10 C300 6,330 14,360 10
           C390 6,420 14,450 10 C480 6,510 14,540 10
           C570 6,600 10,600 10"
        fill="none"
        stroke="var(--color-border-default)"
        stroke-width="1"
      />
    </svg>

    <!-- Center label -->
    <span
      v-if="label"
      class="font-label font-light text-lg tracking-widest
             uppercase text-muted whitespace-nowrap flex-shrink-0"
    >
      {{ label }}
    </span>

    <!-- Right wave (mirrored) -->
    <svg class="flex-1" height="20" viewBox="0 0 600 20"
         preserveAspectRatio="none">
      <path
        d="M0 10 C30 14,60 6,90 10 C120 14,150 6,180 10
           C210 14,240 6,270 10 C300 14,330 6,360 10
           C390 14,420 6,450 10 C480 14,510 6,540 10
           C570 14,600 10,600 10"
        fill="none"
        stroke="var(--color-border-default)"
        stroke-width="1"
      />
    </svg>

  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  label?: string
}>(), {
  label: ''
})
</script>
